import { Actions as EMPLOYEEACTIONS } from "@/redux/actions/employeeActions";
import { useEffect } from "react";
import { connect } from "react-redux";
import { useLocation, useParams } from "react-router-dom";

import ImportPreviousEarningsModal from "../modals/import-previous-earnings-modal/ImportEarningsModal";
import UpdateEmploymentDateModal from "../role/UpdateEmploymentDateModal";
import UpdateTerminationDateModal from "../role/UpdateTerminationDateModal";
// import TaxCreditModal from './tax-credit/TaxCreditModal';
import BambooPushModal from "@/components/integrations/bamboo-hr/BambooPushModal";
import LoadingContent from "../../common/LoadingContent";
import InvalidPermissions from "../../company-pages/InvalidPermissions";
import NoteModal from "../../notes/NoteModal";
import ConfirmModal from "../modals/ConfirmModal";
import DeleteEmployeeDetailsModal from "../modals/DeleteEmployeeDetailsModal";
import GradeApplyModal from "../modals/GradeApplyModal";
import MFAStatusModal from "../modals/MFAStatusModal";
import UpdateEmployeeModal from "../modals/update-employee-modal/UpdateEmployeeModal";

import LayoutRoutes from "buddy/layout/LayoutRoutes";
import LayoutSidebar from "buddy/layout/LayoutSidebar";
import SectionedLayout from "buddy/layout/SectionedLayout";
import EmployeeHeader from "./EmployeeHeader";
import { getEmployeeRoutes, getEmployeeTabs } from "./employeeTabs";
import { useMemo } from "react";
import { groupBy } from "lodash";
import { mapOccupationsForDropdown } from "@/helpers/Remappers";

const Employee = ({
	employee,
	type,
	getEmployeeDetails,
	error,
	userPermissions,
	jurisdiction,
	clearEmployee,
	company,
	occupations,
}) => {
	let { id } = useParams();
	const defaultPath = `/organisation/people/${id}`;
	const tabPaths = useLocation().pathname.replace(defaultPath, "").split("/");

	useEffect(() => {
		if (id) getEmployeeDetails(id);

		return () => {
			clearEmployee();
		};
	}, [id]);

	const [sections, routes] = useMemo(() => {
		const tabs = getEmployeeTabs({ occupations, hasMultiRole: company?.hasMultiRole, type });
		const routes = getEmployeeRoutes(tabs);

		return [tabs, routes];
	}, [JSON.stringify(occupations), company?.hasMultiRole]);

	if (userPermissions == "None" || error) return <InvalidPermissions />;
	if (!employee?.id && !error) return <LoadingContent />;

	return (
		<div className="overflow-hidden h-[calc(100vh-60px)]">
			<div className="content bg-gray-50">
				<EmployeeHeader />
			</div>

			<SectionedLayout>
				<LayoutSidebar
					{...{
						sections,
						defaultPath,
						conditions: {
							hasChildren: employee?.employeeDetails?.hasChildren,
							hasMultiRole: company?.hasMultiRole,
							jurisdiction,
							type,
							tabPaths,
						},
					}}
				/>
				<LayoutRoutes
					{...{
						routes,
						defaultPath,
						conditions: {
							jurisdiction,
							hasChildren: employee?.employeeDetails?.hasChildren,
							hasMultiRole: company?.hasMultiRole,
							type,
							tabPaths,
						},
						componentParams: { agreementId: employee?.id },
					}}
				/>
			</SectionedLayout>

			<ConfirmModal />
			<GradeApplyModal />
			<UpdateEmploymentDateModal />
			<UpdateTerminationDateModal />
			<NoteModal />
			<MFAStatusModal />
			<UpdateEmployeeModal />
			<DeleteEmployeeDetailsModal />
			<ImportPreviousEarningsModal />
			<BambooPushModal />
		</div>
	);
};

const mapStateToProps = (state) => {
	const userPermissions = state?.permissions?.my?.permissions?.people;

	const occupations = state.employee?.agreementInfo?.occupations;

	const roles = groupBy(state.employee?.roles || [], "occupation");
	const departments = groupBy(state.employee?.departments || [], "occupation");
	const pensions = groupBy(state.employee?.pensionPlans || [], "occupation");
	const salaries = groupBy(state.employee?.salaries || [], "occupation");

	const occupationList = mapOccupationsForDropdown(
		occupations?.map((o) => ({
			occupation: o,
			roles: roles[o] || [],
			departments: departments[o] || [],
			pensions: pensions[o] || [],
			salaries: salaries[o] || [],
		})),
		state.company?.settings?.departments,
	);

	return {
		employee: state.employee?.agreementInfo,
		type: state.employee?.agreementInfo?.type || "default",
		error: state?.employee?.error,
		occupations: occupationList,
		userPermissions,
		jurisdiction: state.company?.settings?.jurisdiction,
		pensions: state?.pensions?.group?.list,
		company: state.company?.settings,
	};
};

const mapDispatchToProps = (dispatch) => ({
	getTaxOptions: (options) => dispatch(EMPLOYEEACTIONS.getTaxOptions()),
	getEmployeeDetails: (employeeId) => dispatch(EMPLOYEEACTIONS.getEmployeeDetails(employeeId)),
	clearEmployee: () => dispatch(EMPLOYEEACTIONS.clearEmployee()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Employee);
